exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quillWrapper[data-v-2ce12212] {\n  background-color: white;\n}\n.tf_title_dialog[data-v-2ce12212] {\n  text-overflow: ellipsis;\n  width: calc(100% - 180px);\n  overflow: hidden;\n  white-space: nowrap;\n}\n.btnIntentBot[data-v-2ce12212] {\n  cursor: pointer;\n}\n.tf_removeExemple[data-v-2ce12212] {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.tf_modifExemple[data-v-2ce12212] {\n  position: absolute;\n  right: 42px;\n  top: 0;\n}\n.margRight[data-v-2ce12212] {\n  margin-right: 8px;\n}\n.codeSource[data-v-2ce12212] {\n  background-color: white;\n  border: 1px solid #ccc;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2ce12212","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzFaq.vue
// module id = vfei
// module chunks = 1